import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m11,4h-7L7.5,0l3.5,4ZM20,0h-7l3.5,4,3.5-4Zm4,9v15H0v-15c0-1.654,1.346-3,3-3h18c1.654,0,3,1.346,3,3Zm-10,3.5c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5-1.119-2.5-2.5-2.5-2.5,1.119-2.5,2.5Zm-9,0c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5-1.119-2.5-2.5-2.5-2.5,1.119-2.5,2.5Zm6,6.5c0-1.654-1.346-3-3-3h-1c-1.654,0-3,1.346-3,3v3h7v-3Zm9,0c0-1.654-1.346-3-3-3h-1c-1.654,0-3,1.346-3,3v3h7v-3Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/elevator-icon.jsx